
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1fj9k_q6akd_5",
  "navigation": "awsui_navigation_1fj9k_q6akd_6",
  "navigation-toggle": "awsui_navigation-toggle_1fj9k_q6akd_7",
  "navigation-close": "awsui_navigation-close_1fj9k_q6akd_8",
  "content": "awsui_content_1fj9k_q6akd_9",
  "notifications": "awsui_notifications_1fj9k_q6akd_10",
  "breadcrumbs": "awsui_breadcrumbs_1fj9k_q6akd_11",
  "tools": "awsui_tools_1fj9k_q6akd_12",
  "tools-close": "awsui_tools-close_1fj9k_q6akd_13",
  "tools-toggle": "awsui_tools-toggle_1fj9k_q6akd_14",
  "drawer-closed": "awsui_drawer-closed_1fj9k_q6akd_15",
  "mobile-bar": "awsui_mobile-bar_1fj9k_q6akd_16",
  "disable-body-scroll-root": "awsui_disable-body-scroll-root_1fj9k_q6akd_17",
  "drawers-trigger": "awsui_drawers-trigger_1fj9k_q6akd_18",
  "drawers-trigger-global": "awsui_drawers-trigger-global_1fj9k_q6akd_19",
  "drawers-trigger-with-badge": "awsui_drawers-trigger-with-badge_1fj9k_q6akd_20",
  "active-drawer": "awsui_active-drawer_1fj9k_q6akd_21",
  "active-drawer-close-button": "awsui_active-drawer-close-button_1fj9k_q6akd_22",
  "overflow-menu": "awsui_overflow-menu_1fj9k_q6akd_23",
  "drawers-slider": "awsui_drawers-slider_1fj9k_q6akd_24",
  "toolbar": "awsui_toolbar_1fj9k_q6akd_25",
  "trigger-wrapper-tooltip-visible": "awsui_trigger-wrapper-tooltip-visible_1fj9k_q6akd_26",
  "trigger-tooltip": "awsui_trigger-tooltip_1fj9k_q6akd_27",
  "active-drawer-expanded-mode-button": "awsui_active-drawer-expanded-mode-button_1fj9k_q6akd_28",
  "ai-drawer-toggle": "awsui_ai-drawer-toggle_1fj9k_q6akd_29",
  "active-ai-drawer-leave-expanded-mode-custom-button": "awsui_active-ai-drawer-leave-expanded-mode-custom-button_1fj9k_q6akd_30"
};
  